/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesSearchResultContainer containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum expandRefinersCount {
    all = 'all',
    one = 'one',
    two = 'two',
    three = 'three',
    four = 'four'
}

export interface IDobbiesSearchResultContainerConfig extends Msdyn365.IModuleConfig {
    itemsPerPage?: number;
    itemsPerPageMobile?: number;
    allowBackNavigation?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    expandRefinersCount?: expandRefinersCount;
    disableHierarchy?: boolean;
    includeAttributes?: boolean;
    enableAffiliationBasedPricing?: boolean;
    updateRefinerPanel?: boolean;
    className?: string;
    clientRender?: boolean;
    startingRefinerList?: string[];
    enableOutOfStockButton?: boolean;
    clubPlusBadgeLink?: string;
    tilesForPLP?: ITilesForPLPData[];
    showTilesOnPLP?: boolean;
    repeatSameTile?: boolean;
    tileToAppearAfterProducts?: number;
    maxNumberOfTiles?: number;
    refinerSearchThreshold?: number;
    refinersWithoutSearch?: string[];
    plpBannerLinkTop?: IPlpBannerLinkTopData;
    plpBannerImageDesktopTop?: Msdyn365.IImageData;
    plpBannerImageMobileTop?: Msdyn365.IImageData;
    plpBannerImageIpadTop?: Msdyn365.IImageData;
    plpBannerLinkBottom?: IPlpBannerLinkBottomData;
    plpBannerImageDesktopBottom?: Msdyn365.IImageData;
    plpBannerImageMobileBottom?: Msdyn365.IImageData;
    plpBannerImageIpadBottom?: Msdyn365.IImageData;
}

export interface IDobbiesSearchResultContainerResources {
    noResultsForRefinersText: string;
    resultCategoryNotFoundText: string;
    resultSearchNotFoundText: string;
    paginationAriaLabel: string;
    priceFree: string;
    priceRangeSeparator: string;
    originalPriceText: string;
    currentPriceText: string;
    ratingAriaLabel: string;
    flipperNext: string;
    flipperPrevious: string;
    searchTextPrefix: string;
    numberOfProducts: string;
    oneProduct: string;
    categoryLinkAriaLabel: string;
    sortByDropdownLabel: string;
    sortByOptionNameAsc: string;
    sortByOptionNameDesc: string;
    sortByOptionPriceAsc: string;
    sortByOptionPriceDesc: string;
    sortByOptionRatingDesc: string;
    sortByOptionBestSelling: string;
    sortByOptionNewScore: string;
    sortByOptionTrendingScore: string;
    sortByOptionRelevanceDesc: string;
    placeholderTextMax: string;
    minLabel: string;
    maxLabel: string;
    rangeNameFormat: string;
    validationErrorNotNumber: string;
    validationErrorNotRange: string;
    clearAllText: string;
    choiceSummaryLabel: string;
    choiceFormat: string;
    choiceRangeValueFormat: string;
    choiceAriaLabel: string;
    closeAriaLabel: string;
    modalTitle: string;
    modalCloseButtonText: string;
    minValueSliderThumbAriaLabel: string;
    maxValueSliderThumbAriaLabel: string;
    featureSimilarLooksTitle: string;
    featureSimilarDescriptionTitle: string;
    productCountAriaLabel: string;
    singleProductCountAriaLabel: string;
    swatchItemAriaLabel: string;
    refineItemsAriaLabel: string;
    refineItemAriaLabel: string;
    filterActiveText: string;
    browseButtonText: string;
    outOfStockNavText: string;
    showOutofStockBtn: string;
    hideOutOfStockBtn: string;
}

export interface ITilesForPLPData {
    imageUrl?: string;
    urlForTileClick?: string;
    nameForTile?: string;
    currentTileShouldAppearAfterProducts?: number;
}

export interface IPlpBannerLinkTopData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IPlpBannerLinkBottomData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface IDobbiesSearchResultContainerProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesSearchResultContainerResources;
    config: IDobbiesSearchResultContainerConfig;
    slots: {
        browse: React.ReactNode[];
        quickview: React.ReactNode[];
        productComparisonButton: React.ReactNode[];
        unbxdCarousel: React.ReactNode[];
    };
}
